<template>
  <div class="rolling-box" v-if="msgList.length">
    <van-notice-bar left-icon="volume-o" :scrollable="false">
        <van-swipe
          vertical
          class="notice-swipe"
          :autoplay="3000"
          :show-indicators="false">
          <van-swipe-item v-for="(item, index) in msgList" :key="index">
            {{item.phone}}的用户，刚刚获得了{{item.amount || 0}}元的{{item.type | typeEnum}}
          </van-swipe-item>
        </van-swipe>
      </van-notice-bar>
  </div>
</template>

<script>
export default {
  data() {
    return {
      msgList: []
    }
  },
  methods: {
    getList() {
      if (!this.$route.query.activityId) {
        return;
      }
      this.$api.activityMgmt.getRedPacketRollingList(this.$route.query.activityId)
        .then(({data}) => {
          if (Array.isArray(data)) {
            this.msgList = data;
          }
        });
    }
  },
  filters: {
    typeEnum(value) {
      const map = {
        1: '现金红包',
        2: '裂变佣金'
      };
      return map[value] || ''
    }
  },
  created() {
    this.getList();
  }
}
</script>

<style lang="stylus" scoped>
.rolling-box
  position fixed
  top 0
  left 0
  right 0
  z-index: 999
  padding 5px 10px
  overflow hidden
  background-color: rgba(0,0,0,0.5)
  >>> .van-notice-bar
    padding 0
    height: 24px
    background: transparent
    color #fff
    font-size 12px
  .notice-swipe
    height: 24px
    line-height: 24px
</style>